import React from 'react';
import { formatCurrency } from '../../../lib/utils';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';

export const PaymentDialog = ({
  paymentDialogOpen, setPaymentDialogOpen, selectedBill, paymentData, setPaymentData, handlePayment
}) => (
  <Dialog open={paymentDialogOpen} onOpenChange={setPaymentDialogOpen}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle className="font-[Manrope]">Record Payment</DialogTitle>
      </DialogHeader>
      {selectedBill && (
        <div className="space-y-4 mt-4">
          <div className="p-4 bg-slate-50 rounded-lg">
            <div className="flex justify-between mb-2">
              <span className="text-slate-500">Bill Total</span>
              <span className="font-semibold">{formatCurrency(selectedBill.total_amount)}</span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="text-slate-500">Paid Amount</span>
              <span className="text-emerald-600">{formatCurrency(selectedBill.paid_amount || 0)}</span>
            </div>
            <div className="flex justify-between border-t pt-2">
              <span className="font-medium">Balance Due</span>
              <span className="font-semibold text-red-500">{formatCurrency(selectedBill.total_amount - (selectedBill.paid_amount || 0))}</span>
            </div>
          </div>
          <div>
            <Label>Payment Amount (₹)</Label>
            <Input
              type="number"
              min="0"
              max={selectedBill.total_amount - (selectedBill.paid_amount || 0)}
              value={paymentData.amount}
              onChange={(e) => setPaymentData({...paymentData, amount: parseFloat(e.target.value) || 0})}
              data-testid="payment-amount"
            />
          </div>
          <div>
            <Label>Payment Method</Label>
            <Select value={paymentData.payment_method} onValueChange={(v) => setPaymentData({...paymentData, payment_method: v})}>
              <SelectTrigger data-testid="payment-method">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="cash">Cash</SelectItem>
                <SelectItem value="card">Card</SelectItem>
                <SelectItem value="upi">UPI</SelectItem>
                <SelectItem value="bank_transfer">Bank Transfer</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Reference Number (optional)</Label>
            <Input
              value={paymentData.reference_number}
              onChange={(e) => setPaymentData({...paymentData, reference_number: e.target.value})}
              placeholder="Transaction ID / Receipt No."
              data-testid="payment-ref"
            />
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={() => setPaymentDialogOpen(false)}>Cancel</Button>
            <Button className="bg-red-500 hover:bg-red-600" onClick={handlePayment} data-testid="confirm-payment">Confirm Payment</Button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
